<template>
  <div>
    <Navigation />
    <div class="row tableUsers">
      <div v-if="addNewAdmin" class="popUp-overlay"></div>
      <div v-if="addNewAdmin" class="popUp-dialog zHelper">
        <div class="col-md-12">
          <form>
            <div class="messages"></div>
            <div class="controls">
              <div class="row">
                <div class="col-md-12">
                  <!-- <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="form_name">Admin Name</label>
                    <input
                      id="form_name"
                      type="text"
                      name="name"
                      class="form-control"
                      placeholder=""
                      required="required"
                      data-error="error"
                    />
                  </div> -->
                  <form class="form-group">
                    <label class="floatLeft" for="email">Email:</label>
                    <input
                      v-model="newAdminName"
                      id="email"
                      type="email"
                      name="email"
                      class="form-control mb-3"
                      required="required"
                      data-error="error"
                      v-on:change="showErrorEmail = false"
                    />
                    <div v-show="showErrorEmail" class="red-text">
                      Please enter a valit email: example@mail.com
                    </div>
                    <label for="machine" class="mb-2 floatLeft"
                      >Password:</label
                    >
                    <input
                      v-model="newAdminPassword"
                      id="password"
                      type="password"
                      name="password"
                      class="form-control mb-3"
                      required="required"
                      data-error="error"
                      v-on:change="showErrorPassword = false"
                    />
                    <div v-show="showErrorPassword" class="red-text">
                      Please enter a valid password. The password should
                      containt a Big letter, a number and a special character
                    </div>
                  </form>
                </div>
              </div>
              <div class="row floatLeft">
                <div class="col-md-12">
                  <input
                    v-on:click="submitCreateAdmin()"
                    type="submit"
                    class="btn btnDark btn-success btn-send pointer"
                    value="Submit"
                  />
                  <input
                    v-on:click="closeCreateAdmin()"
                    type="cancel"
                    class="btn btn btn-secondary pointer button-width-helper"
                    value="Cancel"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div v-if="deleteAdmin" class="popUp-overlay"></div>
      <div v-show="deleteAdmin" class="popUp-dialog zHelper">
        <div class="col-md-12">
          <form>
            <div class="messages"></div>
            <div class="controls">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="form_name"
                      >Are you sure you want to delete this Admin?</label
                    >
                    <!-- <input id="form_name" type="text" name="name" class="form-control" placeholder="" required="required" data-error="error"> -->
                  </div>
                </div>
              </div>
              <div class="row floatLeft">
                <div class="col-md-12">
                  <input
                    v-on:click="confirmDelete()"
                    type="submit"
                    class="btn danger btnDark btn-success btn-send pointer"
                    value="Yes"
                  />
                  <input
                    v-on:click="deleteAdmin = false"
                    type="cancel"
                    class="btn btnDark btn-success pointer"
                    value="No"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!-- ---------------------------------------- Undefined Transactions starts here ------------------------------------------------------------- -->
      <!-- Here is the popUp for the review -->
      <div
        v-if="reviewTransaction"
        class="popUp-overlay"
        @keyup.escape="closeReview"
      ></div>
      <div v-if="reviewTransaction" class="undefined-overlay zHelper">
        <div class="container-fluid p-2">
          <div
            class="row justify-content-between m-1 pb-1"
            style="border-bottom: 1px solid #d3d3d3"
          >
            <div class="col-sm-6 text-left tableName">
              <h4>Review Transaction</h4>
            </div>
            <div class="col-sm-6 text-right mt-3">
              <i
                class="far fa-times-circle fa-2x textDec pointer"
                v-on:click="closeReview()"
              ></i>
            </div>
          </div>
        
          <div class="row justify-content-around mb-4" style="width: 100%">
            <div class="col-5">
              <img v-bind:src="ImagesSource" width="200px" height="200" />
            </div>
            <div class="col-7">
              <form class="form-group row">
                <label for="user">User:</label>
                <input
                  v-model="reviewUser.username"
                  id="user"
                  type="text"
                  name="user"
                  class="form-control mb-3"
                  required="required"
                  data-error="error"
                  readonly
                />
                <label for="machine" class="mb-2">Machine:</label>
                <input
                  v-model="reviewUser.Machine_name"
                  id="machine"
                  type="text"
                  name="machine"
                  class="form-control mb-3"
                  required="required"
                  data-error="error"
                  readonly
                />
                <label for="points" class="mb-2">Points:</label>
                <input
                  v-model="selectedBrandPackage.greenpoints"
                  id="points"
                  type="text"
                  name="machine"
                  class="form-control mb-3"
                  required="required"
                  data-error="error"
                  readonly
                />
                <label for="brandPackaging" class="mb-2"
                  >Brand packaging detection:</label
                >
                <select
                  v-model="selectedBrandPackage"
                  name="select_package"
                  class="custom-select custom-select-sm form-control form-control-sm"
                >
                  <option
                    v-bind:key="index"
                    v-for="(brandPackage, index) in brandPackages"
                    v-bind:value="{
                      brandPackId: brandPackage.id,
                      code: brandPackage.code,
                      greenpoints: brandPackage.greenpoints,
                    }"
                  >
                    {{ brandPackage.name }}
                  </option>
                </select>
              </form>
            </div>
          </div>
          <div class="row floatLeft mb-4">
            <div class="col-md-12">
              <input
                v-on:click="
                  submitReview();
                  selectedBrandPackage.incoming_transaction_id = reviewUser.id;
                "
                type="submit"
                class="btn btn-success darkGreen btn-send pointer"
                value="Submit Review"
              />
              <input
                v-on:click="closeReview()"
                type="cancel"
                class="btn btn-secondary pointer button-width-helper"
                value="Cancel"
              />
            </div>
          </div>
        </div>
      </div>
      <!--Here ends the popUp for the review-->
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="toolbar">
              <!-- Here you can write extra buttons/actions for the toolbar -->
            </div>
            <div
              id="datatable_wrapper"
              class="dataTables_wrapper dt-bootstrap4"
            >
             
              <div class="row space-between">
                <div class="col-sm-12 col-md-4 tableName">
                  Undefined transactions
                </div>
                <div class="col-sm-12 col-md-5"></div>
                <div class="col-sm-12 col-md-3 mt-4">
                  <div id="datatable_filter" class="dataTables_filter">
                    <form
                      class="form-inline md-form floatRight searchDiv form-sm active-darkGreen-2 mt-2"
                    >
                      <input
                        v-model="searchTransactions"
                        name="query"
                        v-on:keyup="filterTransactions()"
                        class="form-control borderNone form-control-sm mr-3"
                        type="text"
                        placeholder="Search"
                        aria-label="Search"
                      />
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </form>
                  </div>
                </div>
              </div>
               <div class="row">
              <div class="col-sm-12 col-md-2 mt-1 text-left pl-4 heading">
                Filter by machine:
              </div>
              <div class="col-sm-2">
                <select
                  class="form-control form-control-sm"
                  id="machineFilter"
                  @change="filterByMachineId"
                  v-model="selectedMachineId"
                  required
                >
                  <option
                    v-bind:key="index"
                    v-for="(option, index) in allMachines"
                    v-bind:value="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
              </div>
               <div class="col-sm-12 col-md-8 mt-1 text-right heading clearFilter" type="reset">
                    <button  @click="ClearFilters()">Clear filters</button>
                </div>
              
            </div>
              <div class="row">
                <div class="col-sm-12 min-table-height">
                  <table
                    id="datatable"
                    class="table table-striped table-bordered dataTable dtr-inline"
                    cellspacing="0"
                    width="100%"
                    role="grid"
                    aria-describedby="datatable_info"
                    style="width: 100%"
                  >
                    <thead>
                      <tr role="row">
                        <th
                          class="sorting_asc"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-sort="ascending"
                          aria-label="Name: activate to sort column descending"
                        >
                          User
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-label="Position: activate to sort column ascending"
                        >
                          Detection description
                        </th>
                        <th
                          class="disabled-sorting sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 230px"
                          aria-label="Actions: activate to sort column ascending"
                        >
                          Points
                        </th>
                        <th
                          class="disabled-sorting sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: de 230px"
                          aria-label="Actions: activate to sort column ascending"
                        >
                          Machine name
                        </th>
                        <th
                          class="disabled-sorting sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 230px"
                          aria-label="Actions: activate to sort column ascending"
                        >
                          Date
                        </th>
                        <th
                          class="disabled-sorting sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 230px"
                          aria-label="Actions: activate to sort column ascending"
                        >
                          Review
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        role="row"
                        v-bind:key="index"
                        v-for="(transaction, index) in transactionInfo"
                        v-bind:class="[
                          index % 2 == 0 || index == 0 ? 'even' : 'odd',
                        ]"
                      >
                        <td tabindex="0" class="sorting_1">
                          {{ transaction.username }}
                        </td>
                        <td>{{ transaction.detection }}</td>
                        <td>{{ transaction.points }}</td>
                        <td>{{ transaction.Machine_name }}</td>
                        <td>{{ transaction.createdon }}</td>
                        <td>
                          <a
                            href="#"
                            class="btn btn-round darkGreen btn-success btn-icon btn-sm remove"
                            v-on:click="reviewImages(transaction)"
                            >Review Transaction</a
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <pagination
              :meta_data="transactions_meta_data"
              v-on:next="fetchTransactions"
            ></pagination>
          </div>
          <!-- end content-->
        </div>
        <!--  end card  -->
      </div>
      <!-- end col-md-12 -->
      <!------------------------------------------  Undefined transactions ends here ------------------------------------------------------------- -->
    </div>
  </div>
</template>

<script>
import Navigation from "@/views/Navigation.vue";
import axios from 'axios';
import Pagination from "@/components/Pagination";
import store from "./../store/index";
export default {
  components: {
    Navigation,
    Pagination,
  },
  data() {
    return {
      newAdminName: null,
      newAdminPassword: null,
      showErrorEmail: false,
      showErrorPassword: false,
      searchAdmins: null,
      searchTransactions: null,
      reviewTransaction: false,
      addNewAdmin: false,
      deleteAdmin: false,
      deleteAdminId: null,
      dirAdmin: 0,
      sortAdmin: null,
      orderAdmin: null,
      sortTrans: null,
      orderTrans: null,
      dirTrans: 0,
      transactionInfo: null,
      Admins: null,
      ImagesSource: null,
      brandPackages: null,
      selectedBrandPackage: {
        brandPackId: null,
        code: null,
        greenpoints: 0,
      },
      transaction_id: null,
      admins_meta_data: {
        last_page: null,
        current_page: 1,
        prev_page_url: null,
        perpage: 5,
        total: 0,
      },
      transactions_meta_data: {
        last_page: null,
        current_page: 1,
        prev_page_url: null,
        perpage: 5,
        total: 0,
      },
      allMachines: [],
      selectedMachineId: null
    };
  },
  mounted() {
    this.fetchTransactions();
    this.fetchAdmins();
    this.getAllMachines();
  },
  methods: {
    sortResults(order) {
      this.dirAdmin++;
      this.orderAdmin = order;

      if (this.dirAdmin % 2 == 0) this.sortAdmin = "desc";
      else this.sortAdmin = "asc";
      this.fetchAdmins(
        this.admins_meta_data.current_page,
        this.admins_meta_data.perpage,
        this.searchAdmins,
        this.orderAdmin,
        this.sortAdmin
      );
    },
    fetchAdmins(
      page = this.admins_meta_data.current_page,
      perpage = this.admins_meta_data.perpage,
      search = this.searchAdmins,
      order = this.orderAdmin,
      sort = this.sortAdmin,
      total = this.admins_meta_data.total
    ) {
      axios
        .get(store.state.BASE_URI + "admin/admins/load_admins", {
          headers: { Authorization: localStorage.getItem("accessToken") },
          params: {
            page,
            perpage,
            search,
            order,
            sort,
            total,
          },
        })
        .then((res) => {
          this.Admins = res.data.results.admins;
          var pagination = res.data.results.pagination;
          this.admins_meta_data.last_page = pagination.last_page;
          this.admins_meta_data.current_page = pagination.current_page;
          this.admins_meta_data.prev_page_url = pagination.prev_page_url;
          this.admins_meta_data.perpage = pagination.perpage;
          this.admins_meta_data.search = pagination.search;
          this.admins_meta_data.total = pagination.total;
        });
    },
    
    filterAdmins() {
      this.fetchAdmins(
        this.admins_meta_data.page,
        this.admins_meta_data.perpage,
        this.searchAdmins
      );
    },
    newAdmin() {
      this.$data.addNewAdmin = true;
    },
    del(id) {
      this.$data.deleteAdmin = true;
      this.deleteAdminId = id;
    },
    confirmDelete() {
      axios
        .delete(
          store.state.BASE_URI + "admin/admins/admin/" + this.deleteAdminId,
          { headers: { Authorization: localStorage.getItem("accessToken") } }
        )
        .then((res) => {
          this.fetchAdmins();
          this.deleteAdmin = false;
          this.$toasted
            .show(res.data.message, {
              type: "success",
            })
            .goAway(2000);
        })
        .catch((error) => {
          if (error) {
            this.errorMsg = error.response.data.message;
            this.$toasted
              .show(this.errorMsg, {
                type: "error",
              })
              .goAway(2000);
          }
        });
    },
    //  get brand packages for the select in review
    fetchBrandPacks() {
      axios
        .get(store.state.BASE_URI + "admin/admins/brand_pack_types", {
          headers: { Authorization: localStorage.getItem("accessToken") },
          params: {},
        })
        .then((res) => {
          this.brandPackages = res.data.results.results;
        });
    },
    //   HERE STARTS METHODS FOR TRANSACTION REVIEW
    fetchTransactions(
      page = this.transactions_meta_data.current_page,
      perpage = this.transactions_meta_data.perpage,
      search = this.searchTransactions,
      order = this.orderTrans,
      sort = this.sortTrans,
      total = this.transactions_meta_data.total,
      machine_id =  this.selectedMachineId
    ) {
      axios
        .get(store.state.BASE_URI + "admin/admins/undefined_transactions", {
          headers: { Authorization: localStorage.getItem("accessToken") },
          params: {
            page,
            perpage,
            search,
            order,
            sort,
            total,
            machine_id,
          },
        })
        .then((res) => {
          this.transactionInfo = res.data.results.transactions;
          var pagination = res.data.results.pagination;
          this.transactions_meta_data.last_page = pagination.last_page;
          this.transactions_meta_data.current_page = pagination.current_page;
          this.transactions_meta_data.prev_page_url = pagination.prev_page_url;
          this.transactions_meta_data.perpage = pagination.perpage;
          this.transactions_meta_data.search = pagination.search;
          this.transactions_meta_data.total = pagination.total;
        });
    },
    filterTransactions() {
      this.fetchTransactions(
        this.transactions_meta_data.page,
        this.transactions_meta_data.perpage,
        this.searchTransactions,
        this.selectedMachineId
      );
    },
    reviewImages(transaction) {
      var id = parseInt(transaction.id);
      this.transaction_id = transaction.id;
      this.fetchBrandPacks();
      this.reviewTransaction = true;
      this.reviewUser = transaction;
      axios
        .get(store.state.BASE_URI + "admin/admins/undefined_image_path", {
          headers: { Authorization: localStorage.getItem("accessToken") },
          params: {
            id,
          },
        })
        .then((res) => {
          console.log(res);
          this.ImagesSource = store.state.BASE_URI + res.data.results;
        });
    },
    submitReview() {
      axios.defaults.headers.common["Authorization"] = localStorage.getItem(
        "accessToken"
      );

      axios
        .post(store.state.BASE_URI + "admin/admins/validate_undefined_trans", {
          params: {
            brand_pack_id: this.selectedBrandPackage.brandPackId,
            greenpoints: this.selectedBrandPackage.greenpoints,
            incoming_transaction_id: this.transaction_id,
          },
          headers: {
            "Content-Type": "text/plain;charset=utf-8",
            Authorization: localStorage.getItem("accessToken"),
          },
        })
        .then((response) => {
          this.closeReview();
          this.fetchTransactions();
          this.$toasted
            .show(response.data.message, { type: "success" })
            .goAway(2000);
        })
        .catch((error) => {
          if (error) {
            this.errorMsg = error.response.data.message;
            this.$toasted.show(errorMsg, { type: "error" }).goAway(2000);
          }
        });
      this.closeReview();
    },
    closeReview() {
      this.reviewTransaction = false;
      this.brandPackages = null;
      this.ImagesSource = null;
      this.selectedBrandPackage = {
        brandPackId: null,
        code: null,
        greenpoints: 0,
      };
      this.transaction_id = null;
    },
    closeCreateAdmin() {
      this.newAdminName = null;
      this.newAdminPassword = null;
      this.addNewAdmin = false;
    },
    submitCreateAdmin() {
      if (this.validateEmail() != true && this.validatePassword() != true) {
        this.showErrorEmail = true;
        this.showErrorPassword = true;
      } else if (
        this.validateEmail() != true &&
        this.validatePassword() == true
      ) {
        this.showErrorEmail = true;
        this.showErrorPassword = false;
      } else if (this.validateEmail == true && this.validatePassword != true) {
        this.showErrorEmail = false;
        this.showErrorPassword = true;
      } else {
        axios.defaults.headers.common["Authorization"] = localStorage.getItem(
          "accessToken"
        );

        axios
          .post(store.state.BASE_URI + "admin/admins/create", {
            params: {
              name: this.newAdminName,
              password: this.newAdminPassword,
            },
            headers: {
              "Content-Type": "text/plain;charset=utf-8",
            },
          })
          .then((response) => {
            this.closeCreateAdmin();
            this.fetchAdmins();
            this.$toasted
              .show(response.data.message, { type: "success" })
              .goAway(2000);
          })
          .catch((error) => {
            if (error) {
              this.errorMsg = error.response.data.message;

              this.$toasted.show(this.errorMsg, { type: "error" }).goAway(2000);
            }
          });
        this.closeCreateAdmin();
      }
    },
    validateEmail() {
      var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
      return emailReg.test(this.newAdminName);
    },
    validatePassword() {
      var passRegex = new RegExp(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(\W|_)).{5,}$/
      );
      return passRegex.test(this.newAdminPassword);
    },
    getAllMachines() {
      axios.defaults.headers.common["Authorization"] =
        localStorage.getItem("accessToken");
      axios
        .get(store.state.BASE_URI + "admin/machines/load_all_machines")
        .then((response) => {
          console.log("all machines se", response);
          this.allMachines = response.data.results;
        })
        .catch((error) => {
          console.log("eroro e", error);
          // TODO PUSH NOTIFICATION ERROR
        });
    },
    filterByMachineId(){
      this.filterTransactions();
    },
     ClearFilters() {
      this.transactions_meta_data.current_page = 1,
      this.transactions_meta_data.perpage = 5,
      this.searchTransactions = null,
      this.orderTrans =null,
      this.sortTrans = null,
      this.transactions_meta_data.total =0,
      this.selectedMachineId = null,
       this.fetchResults(
          page = this.transactions_meta_data.current_page,
          perpage = this.transactions_meta_data.perpage,
          search = this.searchTransactions,
          order = this.orderTrans,
          sort = this.sortTrans,
          total = this.transactions_meta_data.total,
          machine_id =  this.selectedMachineId
    );
   
    },
  },
};
</script>

<style src="../css/style.css"></style>
